import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const IntegrationsConfigurationsSkeleton = () => {
  return (
    <Styles.Container>
      <Skeleton variant="text" width="100%" height={1} />
      <Skeleton variant="text" width={120} height={24} />
      <Styles.ConnectedGrid>
        <Skeleton variant="rounded" width="100%" height={72} />
        <Skeleton variant="rounded" width="100%" height={72} />
      </Styles.ConnectedGrid>

      <Skeleton variant="text" width="100%" height={1} />
      <Skeleton variant="text" width={120} height={24} />
      <Skeleton variant="text" width="60%" height={20} />
      <Skeleton variant="text" width={140} height={20} />
      <Styles.AvailableGrid>
        <Skeleton variant="rounded" width="100%" height={72} />
        <Skeleton variant="rounded" width="100%" height={72} />
        <Skeleton variant="rounded" width="100%" height={72} />
        <Skeleton variant="rounded" width="100%" height={72} />
      </Styles.AvailableGrid>
    </Styles.Container>
  )
}

export default IntegrationsConfigurationsSkeleton
